




import {Component, Prop, Vue} from "vue-property-decorator";
import {IdMapper} from "@/interfaces/state/base";
import {CommonStatus} from "@/enums/status";

@Component({
    name: "CommonStatusLabel"
})
export default class extends Vue {
    @Prop({ required: true })
    readonly status!: number;

    CommonStatus = CommonStatus;
    colorMap: IdMapper<string> = {
        [CommonStatus.Active]: 'success',
        [CommonStatus.InActive]: 'error'
    }
}
